<template lang="html">
  <div
      style="padding: 10px 0px;"
    :class="[{
      'with-icon':icon,
    }]"
    :style="styleHeader"
    class="new_titlle flex justify-between">
      <div>
          <div v-if="title" style="font-weight: 500;">{{ title }}</div>
      </div>
      <div>
          <div style="margin-right: 5px;" v-if="lesson.length>0">
<!--              <select v-model="element.status.uid" style="border: rgba(218,225,231,1) 1px solid;">-->
<!--                  <option value="">{{ $t('choose_option') }}</option>-->
<!--                  <option :value="el.uid" v-for="(el,index) in GET_STATUS_COURSE" :key="index">{{ el.name }}</option>-->
<!--              </select>-->
              <multiselect
                  :disabled="user.role.is_supervisor"
                  @select="change_status_flux"
                  :options="GET_STATUS_COURSE"
                  open-direction="bottom"
                  selectedLabel=""
                  v-model="element.status"
                  class="filter_select"
                  label="name"
                  deselectLabel=""
                  :allow-empty="false"
                  selectLabel=""
                  track-by="uid">
                  <div slot="noOptions">
                      {{$t('no_data_text')}}
                  </div>
              </multiselect>
          </div>
      </div>

  </div>
</template>

<script>
import _color from '../vsIcon/color'
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    name:'VsListHeader',
    props: {
        color: {
            type:String,
            default:'primary',
        },
        title:{
            type:String,
            default:null,
        },
        subtitle:{
            type:String,
            default:null,
        },
        icon:{
            type:String,
            default:null,
        },
        iconPack:{
            type:String,
            default:'material-icons',
        },
        lesson:{
            type:Array,
        },
        element:{
            type:Object,
        },
        course_index:{
            type:Number,
        },
        flux_index:{
            type:Number,
        },
        course_uid:{
            type:String,
        }
    },
    computed: {
        ...mapGetters({
            GET_STATUS_COURSE:'discipline_registration_access/GET_STATUS_COURSE'
        }),
        user() {
            return this.$store.state.user.user
        },
        styleHeader () {
            return {
                color: _color.getColor(this.color)
            }
        },
    },
    methods:{
        ...mapActions({
            CHANGE_LESSONS:'online_registration/CHANGE_LESSONS'
        }),
        ...mapMutations({
            CHANGE_STATUS_FLEX_STATE:'discipline_registration_access/CHANGE_STATUS_FLEX_STATE'
        }),
        async get_lessons(){
            let lessons = []
            this.element.lesson_online_registrations.forEach((el)=>{
                lessons.push(el.uid)
            })
            return lessons
        },
        async change_status_flux(value){
            await this.CHANGE_STATUS_FLEX_STATE({
                flux_index:this.flux_index,
                course_index:this.course_index,
                status:value,

            })
            await this.CHANGE_LESSONS({
                data:{
                    data:await this.get_lessons(),
                    status:value?value.uid:null,
                    course_uid:this.course_uid,
                },
                params:{}
            })
        }
    }
}
</script>
<style>
.new_titlle{
    padding: 8px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0px 7px 7px -5px rgba(0,0,0,.08);
    margin-bottom: 5px;
}
</style>
<style lang="scss">
.multiselect__option--selected{
    background-color: rgba(var(--vs-primary), 1);
    color: rgb(255, 255, 255);
}
</style>
